<div [style]="styles.page_header">
  <h1 [style]="styles.general_h1">
    <b *ngIf="isFacilitator; else coachingHeading">The RESPECT Facilitator Styles™</b>
    <ng-template #coachingHeading><b>The RESPECT Coaching Styles™</b></ng-template>
  </h1>
  <table [style]="styles.table">
    <tbody>
      <tr>
        <td [style]="styles.styles.odd">
          Rallier
        </td>
        <td [style]="styles.styles.description_odd">
          Moves people forward to take action, sets up accountability and action plans, and helps spark motivation to create
          measurable results.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.even">
          Educator
        </td>
        <td [style]="styles.styles.description">
          Helps to fill knowledge and skill gaps, shares tools and practices, acts as a conduit of information to increase others'
          capacity and competency.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.odd">
          Strategist
        </td>
        <td [style]="styles.styles.description_odd">
          Assists in finding solutions to problems, partners with others to diagnose the central issue, and creates scenarios and
          plans strategically.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.even">
          Provocateur
        </td>
        <td [style]="styles.styles.description">
          Aids in decision-making by increasing the rigor of thought, questioning assumptions and actions, and poking holes in
          logic.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.odd">
          Explorer
        </td>
        <td [style]="styles.styles.description_odd">
          Guides reflective thought, supports self-discovery, and creates permission for others to think more broadly and open to
          new opportunity.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.even">
          Confidant
        </td>
        <td [style]="styles.styles.description">
          Listens and empathizes deeply, helps others feel seen and appreciated, and models authenticity and vulnerability.
        </td>
      </tr>
      <tr>
        <td [style]="styles.styles.odd">
          Transformer
        </td>
        <td [style]="styles.styles.description_odd">
          Sees the potential in others, assists them in removing barriers to that potential, and helps them process emotions to
          aid in change.
        </td>
      </tr>
    </tbody>
  </table>

  <h1 [style]="styles.general_h1"><b>Expression of the Styles</b></h1>

<table [style]="styles.table">
  <tbody>
    <tr>
      <td [style]="styles.styles.odd">Direct</td>
      <td [style]="styles.styles.description_odd">
        Delivers straight-forward communication, avoids sugar-coating, gets to the point quickly and doesn't mince words.
      </td>
    </tr>
    <tr>
      <td [style]="styles.styles.even">Indirect</td>
      <td [style]="styles.styles.description">
        Delivers communication in a tactful manner, finds palatable ways to make points, uses a roundabout path to increase
        ownership.
      </td>
    </tr>
  </tbody>
</table>

<div [style]="styles.styles.note">
  <ng-container *ngIf="isFacilitator; else coachingNote">
    Note: While this assessment is behaviorally anchored, self-assessment scores are dependent on self- awareness. Scores
    based on expert coding, reviews of transcripts, or participant feedback may vary from those captured here, and
    additional training or reflection may alter your use of the RESPECT Facilitator Styles™ and their expression.
  </ng-container>
  <ng-template #coachingNote>
    Note: While this assessment is behaviorally anchored, self-assessment scores are dependent on self-awareness.
    Scores based on expert coding, reviews of transcripts, or the RESPECT Coaching Styles 360™ may vary from those captured here.
    Additional training or reflection may also alter your use of the RESPECT Coaching Styles™ and their expression.
  </ng-template>
</div>

</div>